import { FaVolleyballBall, FaRunning } from "react-icons/fa";

import { GiFloorPolisher, GiShuttlecock } from "react-icons/gi";
// Hero Image
import heroImage from "../assets/services/epdm-flooring/hero.jpg";
import overview1 from "../assets/services/epdm-flooring/overview1.jpg";
import overview2 from "../assets/services/epdm-flooring/overview2.jpg";
import overview3 from "../assets/services/epdm-flooring/overview3.jpg";
import overview4 from "../assets/services/epdm-flooring/overview4.jpg";
/* =====================================================
   HERO STATS
===================================================== */

// Gallery Images
import gallery1 from "../assets/services/epdm-flooring/gallery1.jpg";
import gallery2 from "../assets/services/epdm-flooring/gallery2.jpg";
import gallery3 from "../assets/services/epdm-flooring/gallery3.jpg";
import gallery4 from "../assets/services/epdm-flooring/gallery4.jpg";

const epdmflooringData = {
  /* =====================================================
     HERO
  ====================================================== */

  slug: "EPDM Flooring",

  title: "EPDM Floor Construction",

  subtitle: "Professional EPDM Floor built with Professional Standard",

  heroImage,

  overviewImages: [overview1, overview2, overview3, overview4],

  heroStats: [
    {
      value: "500+",
      label: "Courts Built",
    },

    {
      value: "15+",
      label: "Years Experience",
    },

    {
      value: "CHF",
      label: "Certified/Standard",
    },

    {
      value: "1 Yr",
      label: "Warranty",
    },
  ],

  breadcrumb: ["Home", "Services", "EPDM-Flooring"],

  /* =====================================================
     OVERVIEW
  ====================================================== */

  overview: {
    title: "Professional EPDM Playground Surfacing",

    description:
      "Quality Sports Surface specializes in designing and installing high-performance EPDM rubber surfacing for children's playgrounds, parks, and recreational areas. We use premium, non-toxic EPDM granules combined with high-grade polyurethane binders to create a seamless, impact-absorbing safety floor. Engineered for maximum shock absorption, weather resistance, UV stability, and wheelchair accessibility, our surfaces meet rigorous international safety standards while providing vibrant, customizable designs that stand the test of time.",
  },

  /* =====================================================
     BENEFITS
  ====================================================== */

  benefits: [
    {
      title: "Maximum Fall Protection",
      description:
        "Engineered to meet EN 1177 and ASTM F1292 standards for critical fall height safety and shock absorption.",
    },

    {
      title: "Non-Toxic & Safe",
      description:
        "Certified under EN 71-3, ensuring the surface is entirely free from harmful heavy metals and toxic chemicals.",
    },

    {
      title: "All-Weather Durability",
      description:
        "High UV resistance and seamless, porous design prevent water pooling and cracking under extreme weather.",
    },

    {
      title: "Low Maintenance",
      description:
        "Minimal maintenance with long-lasting color and surface quality.",
    },
  ],

  /* =====================================================
     CONSTRUCTION PROCESS
  ====================================================== */

  process: [
    {
      step: "01",
      title: "Site Inspection",
      description:
        "Complete site survey, measurements, and technical planning.",
    },

    {
      step: "02",
      title: "Base Preparation",
      description:
        "Concrete or asphalt base preparation with perfect leveling.",
    },

    {
      step: "03",
      title: "Acrylic Coating",
      description:
        "Multiple acrylic layers applied for strength and cushioning.",
    },

    {
      step: "04",
      title: "Court Marking",
      description: "Accurate FIBA-standard basketball court line marking.",
    },

    {
      step: "05",
      title: "Final Inspection",
      description: "Complete quality inspection before project handover.",
    },
  ],

  /* =====================================================
     TECHNICAL SPECIFICATIONS
  ====================================================== */

  specifications: [
    {
      icon: "🎨",
      feature: "Surface Type",
      value: "Seamless Wet-Pour EPDM Rubber",
    },

    {
      icon: "🛡️",
      feature: "Safety Certification",
      value: "EN 1177 / ASTM F1292 Compliant",
    },
    {
      icon: "💧",
      feature: "Permeability",
      value: "Highly Porous (All-Weather Drainage)",
    },
    {
      icon: "☀️",
      feature: "UV Resistance",
      value: "Aliphatic Binder / High UV Stability",
    },
    {
      icon: "🏅",
      feature: "Safety Standards",
      value: "IPEMA & TÜV Certified",
    },
    {
      icon: "⏳",
      feature: "Expected Lifespan",
      value: "5+ Years",
    },
    {
      icon: "🔧",
      feature: "Maintenance",
      value: "Low (Easy Wash & Clean)",
    },
    {
      icon: "🌐",
      feature: "Surface Type",
      value: "Playgrounds & Parks",
    },
  ],

  /* =====================================================
     GALLERY
  ====================================================== */

  gallery: [
    {
      image: gallery1,
      title: "ABC International School",
      location: "New Delhi",
      surface: "Premium Acrylic Basketball Court",
      year: "2025",
    },

    {
      image: gallery2,
      title: "Delhi Public School",
      location: "Jaipur",
      surface: "Professional Acrylic Court",
      year: "2024",
    },

    {
      image: gallery3,
      title: "Sports Academy",
      location: "Lucknow",
      surface: "Outdoor Basketball Court",
      year: "2024",
    },

    {
      image: gallery4,
      title: "University Campus",
      location: "Chandigarh",
      surface: "FIBA Standard Court",
      year: "2023",
    },
  ],

  /* =====================================================
   WHY CHOOSE US — EPDM FLOORING
====================================================== */

  whyChoose: {
    tag: "WHY CHOOSE US",

    title: "Why Choose Our Professional EPDM Flooring Solutions?",

    description:
      "We provide high-performance EPDM flooring solutions designed for safety, durability, comfort and long-term outdoor performance. From premium EPDM rubber materials to professional installation and customized surface finishing, we deliver complete flooring solutions for playgrounds, sports areas, walking tracks, recreational spaces, gyms and other demanding environments.",

    features: [
      {
        title: "15+ Years Experience",
        description:
          "Over 15 years of experience delivering premium rubber flooring and sports surface solutions for schools, universities, playgrounds, academies, clubs, commercial spaces and recreational facilities across India.",
      },

      {
        title: "1000+ Flooring Projects",
        description:
          "Successfully completed 1000+ flooring projects, including EPDM playground surfaces, sports areas, running tracks, recreational spaces, gym flooring and multi-purpose outdoor facilities.",
      },

      {
        title: "Premium EPDM Materials",
        description:
          "We use high-quality EPDM rubber granules and professionally selected flooring materials designed to provide durability, resilience, color stability and reliable long-term performance.",
      },

      {
        title: "Excellent Shock Absorption",
        description:
          "Our EPDM flooring systems provide cushioning and impact absorption, helping create a more comfortable and safer surface for children, athletes and users during running, jumping and recreational activities.",
      },

      {
        title: "Slip-Resistant Surface",
        description:
          "EPDM surfaces are designed to provide controlled traction and reliable grip, helping users move confidently across playgrounds, sports areas, walking tracks and recreational spaces.",
      },

      {
        title: "Weather & UV Resistant",
        description:
          "High-quality EPDM flooring is suitable for outdoor applications and is designed to withstand exposure to sunlight, rain and changing weather conditions while maintaining its performance and appearance.",
      },

      {
        title: "Safe & Comfortable Flooring",
        description:
          "Our EPDM flooring solutions provide a resilient and cushioned surface that helps improve user comfort and reduce the impact associated with falls and repeated physical activity.",
      },

      {
        title: "Vibrant Color Options",
        description:
          "EPDM flooring is available in a wide range of attractive colors, allowing customers to create vibrant playgrounds, sports surfaces, pathways, recreational areas and customized flooring designs.",
      },

      {
        title: "Durable & Long-Lasting",
        description:
          "Premium materials combined with professional installation help EPDM flooring withstand regular foot traffic, outdoor exposure, recreational activities and demanding daily use.",
      },

      {
        title: "Custom EPDM Flooring Solutions",
        description:
          "We provide customized EPDM flooring solutions based on application, surface area, required thickness, subfloor conditions, design preferences, color combinations and project budget.",
      },

      {
        title: "Professional Installation Team",
        description:
          "Our experienced installation team manages surface preparation, base treatment, EPDM layer installation, bonding, finishing and quality checks with attention to surface consistency and durability.",
      },

      {
        title: "Precise Surface Finishing",
        description:
          "Professional installation helps create a smooth, uniform and visually appealing EPDM surface with consistent texture, proper bonding and clean finishing across the entire project area.",
      },

      {
        title: "On-Time Project Delivery",
        description:
          "Our structured project management process ensures efficient execution and helps complete EPDM flooring projects within committed timelines while maintaining installation quality.",
      },

      {
        title: "Complete Project Support",
        description:
          "From consultation and site assessment to material selection, surface preparation, EPDM installation, finishing and maintenance guidance, we provide complete project support.",
      },

      {
        title: "Maintenance & After-Sales Support",
        description:
          "We provide practical maintenance recommendations and ongoing support to help preserve the flooring's appearance, surface performance, durability and overall service life.",
      },
    ],
  },

  /* =====================================================
     FAQ
  ====================================================== */

  faqs: [
    {
      question:
        "What is the standard thickness for an EPDM rubber floor installation?",
      answer:
        "Most sports tracks and playgrounds require a total thickness of 13mm to 15mm. This consists of a 10mm SBR rubber base layer and a 3mm to 5mm EPDM color topcoat.",
    },

    {
      question:
        "what is the difference between SBR rubber and EPDM Rubber granules?",
      answer:
        "SBR rubber is recycled black rubber used for the shock-absording bottom bass layer.EPDM consists of virgin synthetic rubber granuals used for the UV-resistant, coloured top wear layer",
    },

    {
      question:
        "Can EPDM flooring be installed in rainy or cold weather conditons?",
      answer:
        "No, wet-pour EPDM installation requires completely dry conditions and temperatures above 10 degree C.Rain or high humidity during the installation process ruins the polyurethane bindner adhesive, causing the surface to fail.",
    },

    {
      question: "Is EPDM flooring completely seamless and water-permeable?",
      answer:
        "Yes, the wet-pour trowel installation method creates a seamless surface that eliminates tripping hazards. The porous structure allows water to drain straight through the sub-base, preventing puddles.SS",
    },
  ],

  /* =====================================================
         RELATED SERVICES
      ====================================================== */

  relatedServices: [
    {
      icon: GiFloorPolisher,
      title: "Wooden-flooring",
      description: "Professional MFMA Standard Courts",
      link: "/services/wooden-flooring",
    },

    {
      icon: GiShuttlecock,
      title: "Badminton Court",
      description: "Professional BWF Standard Courts",
      link: "/services/badminton-court",
    },

    {
      icon: FaRunning,
      title: "Running Track",
      description: "Athletic Running Track Systems",
      link: "/services/running-track",
    },

    {
      icon: FaVolleyballBall,
      title: "Volleyball Court",
      description: "Professional FIVB Standard Courts",
      link: "/services/volleyball-court",
    },
  ],
  /* =====================================================
     CTA
  ====================================================== */

  cta: {
    title: "Ready to Build Your EPDM Floor?",

    description:
      "Talk with our experts today and get a free consultation for your next sports infrastructure project.",
  },
};

export default epdmflooringData;
